module.exports = {
	"contractName": "CrosslinkShipFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "84:375:4:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;84:375:4;;;;;;",
	"deployedSourceMap": "84:375:4:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;127:124;;-1:-1:-1;;;;;127:124:4;;;;;;;;;-1:-1:-1;;;;;127:124:4;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;255:202:4;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;255:202:4;-1:-1:-1;;;;;255:202:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;127:124:4;192:7;227:19;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;220:26:4;127:124;-1:-1:-1;;127:124:4:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;255:202:4:-;341:4;368:22;407:9;368:49;;430:8;-1:-1:-1;;;;;430:20:4;;:22;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;430:22:4;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;430:22:4;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;430:22:4;;255:202;-1:-1:-1;;;;255:202:4:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;84:375:4:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.18;\n\nimport \"./base/Level.sol\";\nimport \"./CrosslinkShip.sol\";\n\ncontract CrosslinkShipFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    return new CrosslinkShip();\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    CrosslinkShip instance = CrosslinkShip(_instance);\n    return instance.htcIsHauled();\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShipFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShipFactory.sol",
		"exportedSymbols": {
			"CrosslinkShipFactory": [
				607
			]
		},
		"id": 608,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 566,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:4"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 567,
				"nodeType": "ImportDirective",
				"scope": 608,
				"sourceUnit": 2867,
				"src": "26:26:4",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShip.sol",
				"file": "./CrosslinkShip.sol",
				"id": 568,
				"nodeType": "ImportDirective",
				"scope": 608,
				"sourceUnit": 565,
				"src": "53:29:4",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 569,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "117:5:4",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 570,
						"nodeType": "InheritanceSpecifier",
						"src": "117:5:4"
					}
				],
				"contractDependencies": [
					564,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 607,
				"linearizedBaseContracts": [
					607,
					2866,
					2922
				],
				"name": "CrosslinkShipFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 583,
							"nodeType": "Block",
							"src": "201:50:4",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 577,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 572,
										"src": "207:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 578,
									"nodeType": "ExpressionStatement",
									"src": "207:7:4"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 580,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "227:17:4",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_CrosslinkShip_$564_$",
												"typeString": "function () returns (contract CrosslinkShip)"
											},
											"typeName": {
												"contractScope": null,
												"id": 579,
												"name": "CrosslinkShip",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 564,
												"src": "231:13:4",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_CrosslinkShip_$564",
													"typeString": "contract CrosslinkShip"
												}
											}
										},
										"id": 581,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "227:19:4",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_CrosslinkShip_$564",
											"typeString": "contract CrosslinkShip"
										}
									},
									"functionReturnParameters": 576,
									"id": 582,
									"nodeType": "Return",
									"src": "220:26:4"
								}
							]
						},
						"documentation": null,
						"id": 584,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 573,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 572,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 584,
									"src": "151:15:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 571,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "151:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "150:17:4"
						},
						"payable": true,
						"returnParameters": {
							"id": 576,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 575,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 584,
									"src": "192:7:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 574,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "192:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "191:9:4"
						},
						"scope": 607,
						"src": "127:124:4",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 605,
							"nodeType": "Block",
							"src": "349:108:4",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 593,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 588,
										"src": "355:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 594,
									"nodeType": "ExpressionStatement",
									"src": "355:7:4"
								},
								{
									"assignments": [
										596
									],
									"declarations": [
										{
											"constant": false,
											"id": 596,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 606,
											"src": "368:22:4",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_CrosslinkShip_$564",
												"typeString": "contract CrosslinkShip"
											},
											"typeName": {
												"contractScope": null,
												"id": 595,
												"name": "CrosslinkShip",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 564,
												"src": "368:13:4",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_CrosslinkShip_$564",
													"typeString": "contract CrosslinkShip"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 600,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 598,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 586,
												"src": "407:9:4",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 597,
											"name": "CrosslinkShip",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 564,
											"src": "393:13:4",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_CrosslinkShip_$564_$",
												"typeString": "type(contract CrosslinkShip)"
											}
										},
										"id": 599,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "393:24:4",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_CrosslinkShip_$564",
											"typeString": "contract CrosslinkShip"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "368:49:4"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 601,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 596,
												"src": "430:8:4",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_CrosslinkShip_$564",
													"typeString": "contract CrosslinkShip"
												}
											},
											"id": 602,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "htcIsHauled",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 274,
											"src": "430:20:4",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 603,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "430:22:4",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 592,
									"id": 604,
									"nodeType": "Return",
									"src": "423:29:4"
								}
							]
						},
						"documentation": null,
						"id": 606,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 589,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 586,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 606,
									"src": "281:17:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 585,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "281:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 588,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 606,
									"src": "300:15:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 587,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "300:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "280:36:4"
						},
						"payable": false,
						"returnParameters": {
							"id": 592,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 591,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 606,
									"src": "341:4:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 590,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "341:4:4",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "340:6:4"
						},
						"scope": 607,
						"src": "255:202:4",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 608,
				"src": "84:375:4"
			}
		],
		"src": "0:460:4"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShipFactory.sol",
		"exportedSymbols": {
			"CrosslinkShipFactory": [
				607
			]
		},
		"id": 608,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 566,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:4"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 567,
				"nodeType": "ImportDirective",
				"scope": 608,
				"sourceUnit": 2867,
				"src": "26:26:4",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/CrosslinkShip.sol",
				"file": "./CrosslinkShip.sol",
				"id": 568,
				"nodeType": "ImportDirective",
				"scope": 608,
				"sourceUnit": 565,
				"src": "53:29:4",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 569,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "117:5:4",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 570,
						"nodeType": "InheritanceSpecifier",
						"src": "117:5:4"
					}
				],
				"contractDependencies": [
					564,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 607,
				"linearizedBaseContracts": [
					607,
					2866,
					2922
				],
				"name": "CrosslinkShipFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 583,
							"nodeType": "Block",
							"src": "201:50:4",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 577,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 572,
										"src": "207:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 578,
									"nodeType": "ExpressionStatement",
									"src": "207:7:4"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 580,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "227:17:4",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_CrosslinkShip_$564_$",
												"typeString": "function () returns (contract CrosslinkShip)"
											},
											"typeName": {
												"contractScope": null,
												"id": 579,
												"name": "CrosslinkShip",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 564,
												"src": "231:13:4",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_CrosslinkShip_$564",
													"typeString": "contract CrosslinkShip"
												}
											}
										},
										"id": 581,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "227:19:4",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_CrosslinkShip_$564",
											"typeString": "contract CrosslinkShip"
										}
									},
									"functionReturnParameters": 576,
									"id": 582,
									"nodeType": "Return",
									"src": "220:26:4"
								}
							]
						},
						"documentation": null,
						"id": 584,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 573,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 572,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 584,
									"src": "151:15:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 571,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "151:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "150:17:4"
						},
						"payable": true,
						"returnParameters": {
							"id": 576,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 575,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 584,
									"src": "192:7:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 574,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "192:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "191:9:4"
						},
						"scope": 607,
						"src": "127:124:4",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 605,
							"nodeType": "Block",
							"src": "349:108:4",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 593,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 588,
										"src": "355:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 594,
									"nodeType": "ExpressionStatement",
									"src": "355:7:4"
								},
								{
									"assignments": [
										596
									],
									"declarations": [
										{
											"constant": false,
											"id": 596,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 606,
											"src": "368:22:4",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_CrosslinkShip_$564",
												"typeString": "contract CrosslinkShip"
											},
											"typeName": {
												"contractScope": null,
												"id": 595,
												"name": "CrosslinkShip",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 564,
												"src": "368:13:4",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_CrosslinkShip_$564",
													"typeString": "contract CrosslinkShip"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 600,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 598,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 586,
												"src": "407:9:4",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 597,
											"name": "CrosslinkShip",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 564,
											"src": "393:13:4",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_CrosslinkShip_$564_$",
												"typeString": "type(contract CrosslinkShip)"
											}
										},
										"id": 599,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "393:24:4",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_CrosslinkShip_$564",
											"typeString": "contract CrosslinkShip"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "368:49:4"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 601,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 596,
												"src": "430:8:4",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_CrosslinkShip_$564",
													"typeString": "contract CrosslinkShip"
												}
											},
											"id": 602,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "htcIsHauled",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 274,
											"src": "430:20:4",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_view$__$returns$_t_bool_$",
												"typeString": "function () view external returns (bool)"
											}
										},
										"id": 603,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "430:22:4",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 592,
									"id": 604,
									"nodeType": "Return",
									"src": "423:29:4"
								}
							]
						},
						"documentation": null,
						"id": 606,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 589,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 586,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 606,
									"src": "281:17:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 585,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "281:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 588,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 606,
									"src": "300:15:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 587,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "300:7:4",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "280:36:4"
						},
						"payable": false,
						"returnParameters": {
							"id": 592,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 591,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 606,
									"src": "341:4:4",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 590,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "341:4:4",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "340:6:4"
						},
						"scope": 607,
						"src": "255:202:4",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 608,
				"src": "84:375:4"
			}
		],
		"src": "0:460:4"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.796Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/CrosslinkShipFactory.json
// module id = 1028
// module chunks = 0